import Vue from 'vue'
import DateFilter from '@/filters/date/date.format'
import Lowercase from '@/filters/string/lowercase.filter'
import Uppercase from '@/filters/string/uppercase.filter'

Vue.filter('date', DateFilter)
Vue.filter('lowercase', Lowercase)
Vue.filter('uppercase', Uppercase)

export default new Vue()



// WEBPACK FOOTER //
// ./src/filters/index.js